
document.addEventListener('DOMContentLoaded', function () {

  const VideoLoader = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
        const loadVideo = entry.target
        if (!loadVideo.src) {
          loadVideo.src = loadVideo.dataset.src;
          loadVideo.removeAttribute('data-src');
        }   
    }
  });
  }, { 
    rootMargin: "200px", // 预加载距离视口 400px 的视频
  })
  
  const videos = document.querySelectorAll('.yg-lazy-load-video');
  videos.forEach(video => VideoLoader.observe(video));
});